import { LogicalFileType } from '@today/types'

/** The display name of each logical file (TO-391). */
export const FILE_TYPE_LABELS: Readonly<Record<LogicalFileType, string>> = {
	[LogicalFileType.ORGANIZATIONAL]: 'Organizational',
	[LogicalFileType.CLIENTS]: 'Clients',
	[LogicalFileType.CONVERSIONS]: 'Conversions',
	[LogicalFileType.USERS]: 'Users',
	[LogicalFileType.PRODUCTS]: 'Products',
}
